import { IFeatureDonationQuery, useFeatureDonationQuery } from 'generated/sanity-graphql';

const FEATURE_DONATION_SINGLETON_ID = 'feature-donation-singleton';

interface IUseFeatureDonation {
  loading: boolean;
  featureDonation: IFeatureDonationQuery['FeatureDonation'];
}

export const useFeatureDonation = (): IUseFeatureDonation => {
  const { data, loading } = useFeatureDonationQuery({
    variables: { featureDonationId: FEATURE_DONATION_SINGLETON_ID },
  });

  return { loading, featureDonation: data?.FeatureDonation };
};
